import { useNewsCreation } from "@/src/hooks/features/news/use-news-creation";
import ContentCreationForm from "@/src/utils/content-creation-form";
import { useTranslation } from "react-i18next";

export default function NewsCreationScreen() {
  const { t } = useTranslation();
  const {
    form,
    selectedCategoryIds,
    setSelectedCategoryIds,
    visibility,
    setVisibility,
    groupIds,
    setGroupIds,
    visibilityError,
    coverImage,
    setCoverImage,
    attachments,
    handleAddAttachments,
    handleRemoveAttachment,
    infoModal,
    confirmModal,
    handleCreate,
    handleSaveDraft,
    handleCancel,
    showSaveAsDraft,
    isFirstPublish,
    isSubmitting,
  } = useNewsCreation();

  return (
    <>
      <ContentCreationForm
        title={t("LABEL_NEWS_CREATION")}
        onBack={handleCancel}
        control={form.control}
        contentField="Content"
        fields={[
          { name: "Title", label: t("HINT_NEWS_TITLE"), placeholder: t("HINT_ENTER_NEWS_TITLE") },
          { name: "Content", label: t("HINT_NEWS_CONTENT"), placeholder: t("HINT_ENTER_NEWS_CONTENT") },
        ]}
        categoryEntityType="news"
        selectedCategoryIds={selectedCategoryIds}
        onSelectedCategoryIdsChange={setSelectedCategoryIds}
        showVisibility
        visibility={visibility}
        onVisibilityChange={setVisibility}
        groupIds={groupIds}
        onGroupIdsChange={setGroupIds}
        visibilityError={visibilityError}
        coverImage={coverImage}
        onCoverImageChange={setCoverImage}
        coverImageLabel={t("LABEL_NEWS_COVER_IMAGE")}
        attachments={attachments}
        onAddAttachments={handleAddAttachments}
        onRemoveAttachment={handleRemoveAttachment}
        showAttachments
        isLoading={isSubmitting}
        secondaryAction={{ label: t("BTN_CANCEL"), onPress: handleCancel, disabled: isSubmitting }}
        // "Save as Draft" sits next to Cancel on the left — it's an
        // alternative to submitting, not a second primary action. Only shown
        // while creating a new article or editing one that is still a draft;
        // an already-published article has nothing left to "save as draft"
        // (see showSaveAsDraft in use-news-creation).
        secondaryActions={
          showSaveAsDraft
            ? [{ label: t("BTN_SAVE"), onPress: handleSaveDraft, loading: isSubmitting, mode: "outlined" }]
            : []
        }
        primaryActions={[
          {
            label: t(isFirstPublish ? "BTN_CREATE" : "BTN_UPDATE"),
            onPress: handleCreate,
            loading: isSubmitting,
          },
        ]}
        infoModal={infoModal}
        showPinToggle
        confirmModal={confirmModal}
        isPinned={form.watch("isPinned")}
        onPinChange={(val) => form.setValue("isPinned", val)}
      />
    </>
  );
}
